import { ConfigProvider, Input } from 'antd'
import { twMerge } from "tailwind-merge";
import styles from "../../services/styles"

const { COLORS } = styles

export function SL_Input({ className = '', textarea = false, ...rest }) {

    const classes = twMerge(`
        ${className ?? ''}
    `)

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorText: COLORS.GREEN[900],
                    colorTextPlaceholder: COLORS.GRAY[400],
                },
            }}
        >
            {
                textarea ? (
                    <Input.TextArea maxLength={2000} {...rest} className={classes} />
                ) : (
                    <Input maxLength={255} {...rest} className={classes} />
                )
            }
        </ConfigProvider>
    )
}
